import { Component, inject } from '@angular/core';
import { GradientComponent } from '@banyan/commons/components/gradient/gradient.component';
import {
  TransitionStepCardComponent,
} from '@banyan/commons/components/transition-step-card/transition-step-card.component';
import { VerticalStepCardComponent } from '@banyan/commons/components/vertical-step-card/vertical-step-card.component';
import { BgFallbackDirective } from '@banyan/commons/directives/bg-img-fallback.directive';
import { LOCALE } from '@banyan/commons/enum/locale';
import { AccountService } from '@banyan/features/account/services/account.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home-purpose-section',
  standalone: true,
  imports: [
    BgFallbackDirective,
    GradientComponent,
    TransitionStepCardComponent,
    TranslateModule,
    VerticalStepCardComponent,
  ],
  templateUrl: './home-purpose-section.component.html',
  styleUrl: './home-purpose-section.component.scss',
})
export class HomePurposeSectionComponent {
  accountService = inject(AccountService);


  protected readonly LOCALE = LOCALE;

}
